import React from "react";
import { useNavigate } from "react-router";
import UserStore from "../../store/UserStore";
import { observer } from "mobx-react";

const NavigationLink = ({ item, position, classNameForTeamCard = "" }) => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    UserStore.setSelectedContact({ ...item, className: classNameForTeamCard });
    navigate("yourteam");
  };
  return (
    <button
      onClick={handleNavigation}
      className="connect_button_animation buttonBlueBorder connect-navigation-button"
      aria-label={`View Details of ${position}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="12"
        viewBox="0 0 7 12"
        fill="none"
      >
        <path
          d="M4.61525 5.79242L4.90891 6.08673L4.61525 6.38104L0.615485 10.3895L1.34843 11.1225L6.38417 6.08673L1.34843 1.05099L0.615485 1.78393L4.61525 5.79242Z"
          fill="black"
          stroke="black"
          stroke-width="0.833333"
        />
      </svg>
    </button>
  );
};

export default observer(NavigationLink);
